import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {isNullOrUndefined} from '@cs/core';

@Component({
  standalone: false,
  selector: 'cs-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styles: [`
    :host {
      display: block;
      padding: 16px 8px;
    }

    [mat-dialog-title] {
      margin-bottom: 8px;
    }

    [mat-dialog-content] p {
      margin: 0 0 8px;
    }

    [mat-dialog-actions] {
      display: flex;
      gap: 8px;
      padding: 8px 24px 16px;
    }

    [mat-dialog-actions] .btn {
      min-width: 96px;
      padding: 8px 16px;
    }
  `]
})
export class ConfirmationDialogComponent implements OnInit {

  constructor(
	  public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (!isNullOrUndefined(this.data)) {
      this.data.message = (<string>this.data.message).replace(/\n/g, '<br />');
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
